import { render, staticRenderFns } from "./WorkMain.vue?vue&type=template&id=7c32af51&scoped=true"
import script from "./WorkMain.vue?vue&type=script&lang=js"
export * from "./WorkMain.vue?vue&type=script&lang=js"
import style0 from "./WorkMain.vue?vue&type=style&index=0&id=7c32af51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c32af51",
  null
  
)

export default component.exports